(() => {
  const timer = document.querySelector('[data-cart-countdown]');
  if (timer) {
    const key = 'gift-cart-expiry';
    let deadline = Number(sessionStorage.getItem(key));
    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + 10 * 60 * 1000;
      sessionStorage.setItem(key, String(deadline));
    }
    const renderTimer = () => {
      const remaining = Math.max(0, deadline - Date.now());
      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      timer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };
    renderTimer();
    window.setInterval(renderTimer, 1000);
  }

  const changeQuantity = async (input, quantity) => {
    input.disabled = true;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(input.dataset.line), quantity })
      });
      if (!response.ok) throw new Error('Unable to update cart');
      window.location.reload();
    } catch (error) {
      input.disabled = false;
      window.alert(error.message);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-minus], [data-cart-plus]');
    if (!button) return;
    const item = button.closest('[data-cart-line]');
    const input = item?.querySelector('[data-cart-quantity]');
    if (!input) return;
    const delta = button.hasAttribute('data-cart-plus') ? 1 : -1;
    changeQuantity(input, Math.max(0, Number(input.value) + delta));
  });

  const previewModal = document.querySelector('[data-cart-preview-modal]');
  const previewImage = previewModal?.querySelector('[data-cart-preview-image]');
  let previewTrigger = null;

  const closePreview = () => {
    if (!previewModal) return;
    previewModal.hidden = true;
    document.body.classList.remove('gift-cart-preview-open');
    previewImage.removeAttribute('src');
    previewTrigger?.focus();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cart-preview]');
    if (trigger && previewModal && previewImage) {
      event.preventDefault();
      previewTrigger = trigger;
      previewImage.src = trigger.dataset.previewSrc;
      previewImage.alt = trigger.dataset.previewAlt || 'Product preview';
      previewModal.hidden = false;
      document.body.classList.add('gift-cart-preview-open');
      previewModal.querySelector('[data-cart-preview-close]')?.focus();
      return;
    }

    if (event.target.closest('[data-cart-preview-close]')) closePreview();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && previewModal && !previewModal.hidden) closePreview();
  });
})();
